import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { formatDateLong } from '@/shared/formatters';
import type { CertificadoAcessosArbitral } from '../../../types/certificadoAcessosTypes';
interface SecaoCapaProps {
  certificado: Pick<CertificadoAcessosArbitral, 'dataEmissao' | 'numeroProcesso' | 'codigoAutenticacao'>;
  eyebrow?: string;
  titulo?: string;
  numeroLabel?: string;
  dataLabel?: string;
  dataValor?: string;
}
export function SecaoCapa(t0) {
  const $ = _c(37);
  const {
    certificado,
    eyebrow: t1,
    titulo: t2,
    numeroLabel: t3,
    dataLabel: t4,
    dataValor
  } = t0;
  const eyebrow = t1 === undefined ? "Processo Arbitral" : t1;
  const titulo = t2 === undefined ? "Certificado de Acessos" : t2;
  const numeroLabel = t3 === undefined ? "Processo N\xBA" : t3;
  const dataLabel = t4 === undefined ? "Data de emiss\xE3o" : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="bg-brand-600 w-[3px] rounded-[2px]" />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== eyebrow) {
    t6 = <div className="mb-[9px] text-[10.5px] font-semibold tracking-[2.5px] text-neutral-400 uppercase">{eyebrow}</div>;
    $[1] = eyebrow;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== titulo) {
    t7 = <h1 className="text-brand-600 m-0 text-[22px] leading-[1.1] font-semibold tracking-[-0.5px] sm:text-[27px] sm:whitespace-nowrap">{titulo}</h1>;
    $[3] = titulo;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t6 || $[6] !== t7) {
    t8 = <div className="flex items-stretch gap-[15px]">{t5}<div>{t6}{t7}</div></div>;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Image src="/Logo.svg" alt="Arbitralis" width={110} height={26} className="mt-[2px] h-[26px] w-auto" />;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t8) {
    t10 = <div className="mb-7 flex items-start justify-between">{t8}{t9}</div>;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== dataLabel) {
    t11 = <div className="mb-[3px] text-[11px] tracking-[0.4px] text-neutral-400 uppercase">{dataLabel}</div>;
    $[11] = dataLabel;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== certificado.dataEmissao || $[14] !== dataValor) {
    t12 = dataValor ?? formatDateLong(certificado.dataEmissao);
    $[13] = certificado.dataEmissao;
    $[14] = dataValor;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t12) {
    t13 = <div className="text-[13.5px] text-neutral-700">{t12}</div>;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11 || $[19] !== t13) {
    t14 = <div>{t11}{t13}</div>;
    $[18] = t11;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== numeroLabel) {
    t15 = <div className="mb-[3px] text-[11px] tracking-[0.4px] text-neutral-400 uppercase">{numeroLabel}</div>;
    $[21] = numeroLabel;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== certificado.numeroProcesso) {
    t16 = <div className="text-[13.5px] text-neutral-700">{certificado.numeroProcesso}</div>;
    $[23] = certificado.numeroProcesso;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t15 || $[26] !== t16) {
    t17 = <div>{t15}{t16}</div>;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== certificado.codigoAutenticacao) {
    t18 = certificado.codigoAutenticacao && <div><div className="mb-[3px] text-[11px] tracking-[0.4px] text-neutral-400 uppercase">Autenticação</div><div className="text-[13.5px] text-neutral-700">{certificado.codigoAutenticacao}</div></div>;
    $[28] = certificado.codigoAutenticacao;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t14 || $[31] !== t17 || $[32] !== t18) {
    t19 = <div className="flex gap-10 pl-[18px]">{t14}{t17}{t18}</div>;
    $[30] = t14;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t10 || $[35] !== t19) {
    t20 = <div className="border-b border-solid border-neutral-200 px-[37px] pt-[38px] pb-6">{t10}{t19}</div>;
    $[34] = t10;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  return t20;
}